import * as React from 'react';
import { IPlaceholderProps } from './placeholder.interface';
import { Typography, Box, Theme } from '@mui/material';
import { LogoIcon } from '../icons';

export const PlaceholderDefault: React.FC<IPlaceholderProps> = (
  props: IPlaceholderProps
) => {
  const { title, subtitle, children } = props;
  const rootSx = [
    (theme: Theme) => ({
      display: 'inline-flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: props.width ?? '100%',
      height: props.height ?? '100%',
      color: theme.palette.text.secondary,
      flex: 1,
      padding: theme.spacing(2, 0),
    }),
    ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
  ];
  return (
    <Box sx={rootSx}>
      <Box mb={1}>
        <LogoIcon color="disabled" sx={{ fontSize: 80 }}></LogoIcon>
      </Box>
      {/* </div> */}
      {title && <Typography variant="h6">{title}</Typography>}
      {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
      {children}
    </Box>
  );
};
